function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1856",
  "data-name": "Group 1856",
  transform: "translate(-49.5 -601.5)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 30,
  cy: 30,
  r: 30,
  transform: "translate(50 602)",
  fill: "none",
  stroke: "#25a4b4",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_12",
  "data-name": "Group 12",
  transform: "translate(67.234 623.094)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  width: 17.578,
  height: 17.578,
  rx: 2,
  fill: "#25a4b4"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7",
  "data-name": "Path 7",
  d: "M0,5.166a1.172,1.172,0,0,1,.522-.975L5.209,1.066a1.172,1.172,0,0,1,1.822.975v13.2a1.172,1.172,0,0,1-1.822.975L.522,13.09A1.172,1.172,0,0,1,0,12.114Z",
  transform: "translate(19.922 0.149)",
  fill: "#25a4b4"
})));

var SvgAddVideo = function SvgAddVideo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddVideo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add-video.b35f9f4d.svg";
export { ForwardRef as ReactComponent };